@if (visible) {
    <div ngDraggable
         class="debug">
        <ion-button size="small"
                    shape="round"
                    class="ion-float-end"
                    fill="clear"
                    color="secondary"
                    (click)="visible=!visible">
            <ion-icon slot="icon-only"
                      color="primary"
                      name="close"></ion-icon>
        </ion-button>
        <h3>Memory usage</h3>
        <pre>{{ memoryUsage }}</pre>
    </div>
}
